import { types } from './actions.js'

const initialState = {
  visible: false,
  locked: false,
  fixed: false
}

export default function reducer(state = initialState, action) {
  if (action.type === types.DISPLAY_NAVBAR) {
    return {
      ...state,
      visible: action.visible
    }
  }

  if (action.type === types.SET_FIXED) {
    return {
      ...state,
      fixed: action.fixed
    }
  }

  if (action.type === types.SET_LOCKED) {
    return {
      ...state,
      locked: action.locked
    }
  }
  return state
}